import React, { useContext } from "react";
import { isEmpty, lensPath, set } from "ramda";
import { MediaContext } from "../../common/media-context";
import { useSelector } from "react-redux";
import { hasAdminRole } from "../../../auth/authUtils";
import { Box } from "@mui/material";

import MediaStatusSelect from "../../common/MediaStatusSelect";
import { notBlank } from "../../../util/ext";

const EditMediaStatusColumn = props => {
  const auth = useSelector(state => state.auth);
  const context = useContext(MediaContext);

  const handleStatusChange = event => {
    // if value is "", set status as null
    const value = isEmpty(event.target.value) ? null : event.target.value;
    context.setMedia(set(lensPath(["status"]), value));
  };

  return (
    <Box pr={10} display="flex" justifyContent="flex-end">
      <Box width="150px" height="36px">
        {notBlank(context.media) && (
          <MediaStatusSelect
            mediaType={context.media.mediaType}
            disabled={!hasAdminRole(auth.user)}
            value={context.media.status || ""}
            onChange={handleStatusChange}
          />
        )}
      </Box>
    </Box>
  );
};

export default EditMediaStatusColumn;
